export const ActionTypes = {
    GET_AGENDA_BY_ID: "GET_AGENDA_BY_ID",
    GET_AGENDA_LIST:"GET_AGENDA_LIST",
    SET_MEETING_TYPE_FILTER_WIDTH:"SET_MEETING_TYPE_FILTER_WIDTH",
    SET_AGENDA_SELECTED_TAB:"SET_AGENDA_SELECTED_TAB",
    SET_AGENDA_DURATION_FILTER: "SET_AGENDA_DURATION_FILTER",
    GET_MEETING_TYPE_AGENDA_LIST:"GET_MEETING_TYPE_AGENDA_LIST",
    GET_MEETING_TYPE_AGENDA_LIST_WITH_ARCHIVE:"GET_MEETING_TYPE_AGENDA_LIST_WITH_ARCHIVE",
    RESET_STATE: 'RESET_STATE',
    MEETING_BY_AGENDA: "MEETING_BY_AGENDA",
    NEW_MEETING_BY_AGENDA: "NEW_MEETING_BY_AGENDA",
    AGENDA_MEETING_CHAT: 'AGENDA_MEETING_CHAT',
    AGENDA_MEETING_CHAT_PARTICIPANTS: 'AGENDA_MEETING_CHAT_PARTICIPANTS',
    MEETING_CHAT_COMMENTS: 'MEETING_CHAT_COMMENTS',
    SET_FIRST_MONTH_OF_YEAR: 'SET_FIRST_MONTH_OF_YEAR',
    SET_ACTIVE_AGENDA_UI_TAB: 'SET_ACTIVE_AGENDA_UI_TAB',
    SIGNATURE_PROVIDER: 'SIGNATURE_PROVIDER',
    OBSERVER_LIST: 'OBSERVER_LIST',
    GET_LCA_DATA: 'GET_LCA_DATA',
    GET_CONSOLIDATED_LCA_DATA: 'GET_CONSOLIDATED_LCA_DATA',
    GET_LCA_COMPANIES: 'GET_LCA_COMPANIES',
    GET_LCA_FISCAL_TERMS: 'GET_LCA_FISCAL_TERMS',
    SET_LCA_TAB: 'SET_LCA_TAB',
};
